import type { StarRoadRewardType } from 'src/types/starRoad.types';

export const TIER_ROW_HEIGHT = 176;

export const RAIL_CAP = 12;

export const FOOT_STAR_OVERHANG = 47 / 2;

export const FOOT_ROOM = 50 + FOOT_STAR_OVERHANG;

export const BANNER_ROOM = 36;

export const WIDGET_BORDER = 'border-secondary-darkest';
export const WIDGET_GRADIENT = 'bg-star-road-widget';

export const DECOR_ROAD_CARD = 'star-road/card-road-v1.svg';
export const DECOR_MISSIONS_CARD = 'star-road/card-missions-v1.svg';

export const ICON_STAR_BAR = 'star-gradient-filled.svg';
export const STAR_BAR_CLASSES = '[&>path]:stroke-warning-goldEdge';

export const ICON_STAR = 'star.svg';

export const ICON_STAR_PILL = ICON_STAR;
export const STAR_PILL_CLASSES =
  'fill-warning-neutral [&>path:first-of-type]:fill-structural-darkest';

export const ICON_STAR_FOOT = ICON_STAR;
export const STAR_FOOT_EMPTY_CLASSES =
  'fill-secondary-light [&>path:first-of-type]:fill-secondary-medium';
export const STAR_FOOT_FILLED_CLASSES =
  'fill-warning-lightest [&>path:first-of-type]:fill-warning-neutral';

export const ICON_BABZ = 'star-road/babz-sm-v3.svg';
export const ICON_BLINGZ = 'star-road/blingz-sm-v3.svg';
export const ICON_BLIZZ = 'star-road/blizz-sm-v3.svg';
export const ICON_CARD_PACK = 'card/pack.svg';

export const ICON_BABZ_PILL = 'babz.svg';
export const ICON_BLINGZ_PILL = 'star-road/blingz-pill-v2.svg';
export const ICON_BLIZZ_PILL = 'star-road/blizz-pill-v2.svg';
export const ICON_GIFT = 'gift2.svg';
export const GIFT_CLASSES = 'fill-structural-darkest';

export const IMAGE_SPACE_BG = 'star-road/space-bg-v2.svg';
export const IMAGE_HELP_NEW_QUIZ = 'star-road/help-new-quiz.webp';
export const IMAGE_HELP_REPLAY_QUIZ = 'star-road/help-replay-quiz.webp';

export const badgeIconName = (badgeCode: string): string =>
  `badges/icons/${badgeCode}.svg`;

export const badgeHolderName = (badgeCode: string): string =>
  `badges/holders/${badgeCode.replace(/_\d+$/, '')}.svg`;

export const REWARD_ICONS: Record<StarRoadRewardType, string> = {
  BABZ: ICON_BABZ,
  BLINGZ: ICON_BLINGZ,
  BLIZZ: ICON_BLIZZ,
  CARD_PACK: ICON_CARD_PACK,
  BADGE: ICON_STAR,
};

const CURRENCY_ICON_TIERS: Record<'BABZ' | 'BLINGZ' | 'BLIZZ', string[]> = {
  BABZ: [
    'star-road/babz-tilted-v2.svg',
    'star-road/babz-plus5-v2.svg',
    'star-road/babz-plus15-v2.svg',
    'star-road/babz-plus35-v2.svg',
  ],
  BLINGZ: [
    'star-road/blingz-tilted-v2.svg',
    'star-road/blingz-plus5-v2.svg',
    'star-road/blingz-plus15-v2.svg',
    'star-road/blingz-plus35-v2.svg',
  ],
  BLIZZ: [
    'star-road/blizz-tilted-v2.svg',
    'star-road/blizz-plus5-v2.svg',
    'star-road/blizz-plus15-v2.svg',
    'star-road/blizz-plus35-v2.svg',
  ],
};

export const rewardIconName = (
  rewardType: StarRoadRewardType,
  rewardAmount: number,
): string => {
  const tiers = CURRENCY_ICON_TIERS[rewardType as 'BABZ' | 'BLINGZ' | 'BLIZZ'];
  if (!tiers) return REWARD_ICONS[rewardType];
  const step = [5, 15, 35].filter((floor) => rewardAmount >= floor).length;
  return tiers[step] ?? REWARD_ICONS[rewardType];
};

export const REWARD_PILL_BG: Record<StarRoadRewardType, string> = {
  BABZ: 'bg-warning-neutral text-structural-darkest',
  BLINGZ: 'bg-blingz-neutral',
  BLIZZ: 'bg-textBlue',
  CARD_PACK: 'bg-primary-darkest',
  BADGE: 'bg-structural-darkest',
};

export const REWARD_ART_BOX = 'max-h-[62px] max-w-[60px]';

export const BOOSTER_ART_BOX = '-bottom-4 w-12 aspect-[367/691]';
export const BOOSTER_ART_TILT = '-rotate-[9.126deg]';

export const TIER_CARD_LOCKED = 'bg-secondary-lighter';

export const TIER_CARD_REACHED =
  'bg-gradient-to-b from-warning-goldBright to-warning-neutral';

export const TRACK_RAIL_LOCKED = 'bg-secondary-dark';
export const TRACK_RAIL_REACHED =
  'bg-gradient-to-b from-warning-goldBright to-warning-neutral';

export const CLAIM_GRID_SLOTS = 9;
